export class BusinessHelper {
  static IsPolicyNumber(number: string): boolean {
    let re: RegExp = new RegExp('^([a-zA-Z]{1,3})(\\d{4,7})$'); // AANNNNNNN || ANNNNNNN
    return re.test(number);
  }

  static IsClaimNumber(number: string): boolean {
    let re: RegExp = new RegExp('^\\d{8,10}$'); // NNNNNNNNN
    return re.test(number);
  }

  static IsBillingNumber(number: string): boolean {
    let re: RegExp = new RegExp('^\\d{3,5}-\\d{6,8}$'); // NNNN-NNNNNNN
    return re.test(number);
  }

  static IsCustomerLookup(number: string) {
    number = number.trim();
    return this.IsPolicyNumber(number) || this.IsClaimNumber(number) || this.IsBillingNumber(number);
  }
}
